export const FONT_WEIGHTS = {
  medium: 500,
  semibold: 600,
  bold: 700,
};
export const LETTER_SPACINGS = {
  tight: '-0.035em',
  wide: '0.025em',
};

export const h1 = {
  fontSize: '72px',
  fontWeight: FONT_WEIGHTS.bold,
  letterSpacing: LETTER_SPACINGS.tight,
};
export const h2 = {
  fontSize: '60px',
  fontWeight: FONT_WEIGHTS.bold,
  letterSpacing: LETTER_SPACINGS.tight,
};
export const h3 = {
  fontSize: '48px',
  fontWeight: FONT_WEIGHTS.bold,
  letterSpacing: LETTER_SPACINGS.tight,
};
export const h4 = {
  fontSize: '36px',
  fontWeight: FONT_WEIGHTS.bold,
  letterSpacing: LETTER_SPACINGS.tight,
};
export const h5 = {
  fontSize: '30px',
  fontWeight: FONT_WEIGHTS.semibold,
};
export const h6 = {
  fontSize: '24px',
  fontWeight: FONT_WEIGHTS.semibold,
};
export const p = {
  fontSize: '20px',
  fontWeight: FONT_WEIGHTS.medium,
};
